export function parseWholeNumberToPercent(value: string): number {
  return Number.parseFloat(value) / 100;
}
